import React, { Component } from 'react';

//componentes
import Preescolar from './preescolar'

class Index extends Component {

    render(){
        return(
            <div>
                <Preescolar />
            </div>
        );
    }

}
export default Index;